import jquery from 'jquery';

// lodash
import _clone from 'lodash/clone';
import _debounce from 'lodash/debounce';
import _isNull from 'lodash/isNull';
import _isUndefined from 'lodash/isUndefined';
import _merge from 'lodash/merge';
import _round from 'lodash/round';
import _size from 'lodash/size';
import _toFinite from 'lodash/toFinite';
import _toInteger from 'lodash/toInteger';
import _toNumber from 'lodash/toNumber';
import _unset from 'lodash/unset';
import _words from 'lodash/words';

import EventBus from '@/event-bus';
import haveSameKeys from '@/helpers/haveSameKeys';
import getCartItemAccessoriesData from '@/helpers/getCartItemAccessoriesData';

let _bindEventsInitialized = false;

/**
 * Класс для работы с полем кол-во товара
 * @class
 * @memberof ProductInstance
 * @alias quantity
 *
 * @private
 */
var InstanceQuantity = function(config, $parentNode) {
  var self = this;
  var _settings;

  // задаем базывае
  self.selectors = config.settings.selectors.quantity;
  self.instanceId = config.instanceId;

  // привязываем узелы
  self.$node = self._getContainerNode($parentNode);
  self.warehouse_id = self.$node.parents('form:first').data('warehouseId');
  self.node = self.$node[0];
  self.$input = self._getInputNode();

  self.status = {
    inited: false,
    change: false,
    more: false,
    less: false,
    checked: true,
    stockOut: false,
    lastButton: null
  };

  self.variant = {};

  self.quantity = {
    max: 10000000,
    min: 0
  };

  self.unit = config.product.unit;
  self.setConfig(config.settings);

  _merge(self.quantity, {
    current: self._getQuantity(),
    toCheck: self._getQuantity()
  });

  // привязываем экземпляр к узлу
  self.node.Quantity = self;

  self._bindEvents();

  if (self.$node.length > 1) {
    console.log('Double quantity: ', self.$node);
  }

  self.status.inited = true;

  return self;
};

/**
 * Получаем $product элемент динамически,
 * @private
 */
InstanceQuantity.prototype._getProduct = function() {
  var self = this;

  return self.$input.parents('[data-product-id]');
};

/**
 * @private
 */
InstanceQuantity.prototype._getContainerNode = function($parentNode) {
  var self = this;
  var _container;

  _container = $parentNode.find(self.selectors.container.css);

  if (!_container.length) {
    _container = self._buildQuantity($parentNode);
  }

  return _container;
};

/**
 * @private
 */
InstanceQuantity.prototype._getInputNode = function() {
  var self = this;
  var _input;

  _input = self.$node.find(self.selectors.input.css);

  if (!_size(_input)) {
    console.warn('Не указано поле для задания кол-ва товара в блоке ', self.$node);
    _input = false;
  }

  return _input;
};

/**
 * @private
 * Строим считалку, если такой нет
 */
InstanceQuantity.prototype._buildQuantity = function($parentNode) {
  var self = this;
  var _quantity;

  //console.warn('InSales JS API: Вы не указали разметку для кол-ва товаров в блоке ', $parentNode);

  _quantity = jquery('<div ' + self.selectors.container.css + ' class="hidden" style="display: none"></div>');
  _quantity.append('<input name="quantity" value="1">');
  //console.debug('InstanceQuantity: _buildQuantity: _quantity', _quantity);

  return _quantity;
};

/**
 * @private
 */
InstanceQuantity.prototype.setConfig = function(settings) {
  var self = this;
  var _settings = self._getConfig();

  self.settings = settings.quantity;

  self.decimal = _toInteger(self.settings.decimal[self.unit]) || 0;

  self.step = self._fixValue(_settings.step || Math.pow(10, -1 * self.decimal));

  var min = (_isUndefined(_settings.min)) ? self.step : _settings.min;
  self.quantity.min = self._fixValue(min);

  if (self.status.inited) {
    self._check(null, 'setConfig');
  }

  return;
};

/**
 *
 */
InstanceQuantity.prototype._getVariant = function() {
  var self = this;
  var _variant;

  return _variant;
};

/**
 * Забираем data- из поля ввода
 * data-quantity - '' или id variant
 * data-step - шаг
 * data-min - минимальное
 *
 * @private
 */
InstanceQuantity.prototype._getConfig = function() {
  var self = this;
  var _config = self.$node.data() || {};

  return _config;
};

/**
 * Забираем текущее значение
 * @private
 */
InstanceQuantity.prototype._getQuantity = function() {
  var self = this;

  var _value = self.$input.val();
  _value = _value ? _value.replace(',', '.').replace(/[^0-9.-]/g, '') : self.quantity.min;

  return self._fixValue(_value);
};

/**
 * Указываем вариант, с которым работаем ???
 */
InstanceQuantity.prototype.setVariant = function(variant) {
  var self = this;
  var _settings;

  if (variant.id == self.variant.id) {
    return;
  }

  self.variant = variant;

  // определяем максимум
  if (self.settings.useMax) {
    if (!_isNull(self.variant.quantity)) {
      self.status.stockOut = !self.variant.quantity;
      self.quantity.max = self._fixValue(self.variant.quantity);
    } else {
      self.status.stockOut = false;
      self.quantity.max = null;
    }
  }

  self._check({ setVariant: true }, 'setVariant');
};

/**
 * Получение текущего количества и прочей инфы
 * @private
 */
InstanceQuantity.prototype.get = function() {
  var self = this;
  var _quantity = _clone(self.quantity);
  _unset(_quantity, 'toCheck');

  if (!self.settings.useMax) {
    _unset(_quantity, 'max');
  }

  return _quantity;
};

/**
 * Добавляем значение по клику на кнопку
 * @private
 */
InstanceQuantity.prototype._changeQuantity = function(value, byButton) {
  var self = this;

  self.quantity.toCheck += self._fixValue(value);

  self._check(byButton, 'changeQuantity');
};

/**
 * Устанвливаем новое значение при изменении поля
 * @private
 */
InstanceQuantity.prototype._setQuantity = function() {
  var self = this;

  self.quantity.toCheck = self._getQuantity();

  self._check(null, 'setQuantity');
};

/**
 * Проверка
 * @private
 */
InstanceQuantity.prototype._check = function(config, method, notNeedCartUpdate) {
  var self = this;

  // При работе со складами достаём остаток товара из мультикорзины
  if (self.warehouse_id && window.Cart.order.multi_orders && window.Cart.order.multi_orders[self.warehouse_id]) {
    let current_warehouse_cart = window.Cart.order.multi_orders[self.warehouse_id];

    if (current_warehouse_cart.items[self.variant.id] && current_warehouse_cart.items[self.variant.id].variant_quantity) {
      self.quantity.max = _toNumber(current_warehouse_cart.items[self.variant.id].variant_quantity);
    }
  }

  var _isSetVariant = config ? config.setVariant : false;
  var _isSetByButton = config ? config.byButton : false;
  // Получаем актуальный элемент динамически
  var $product = self._getProduct();

  self.status.more = false;
  self.status.less = false;
  self.status.lastButton = config ? config.button : null;

  if (self.status.checked) {
    self.status.change = false;
  }

  self.status.checked = false;

  // Переустанавливаем стартовое значение при переключении варинатов.
  // На случай, если предыдущий был 0, для нового ставим 1 и прогоняем проверки
  if (_isSetVariant && self.quantity.toCheck == 0 && self.quantity.min > 0) {
    self.quantity.toCheck = 1;
  }

  if (_isSetByButton && self.quantity.toCheck < 0) {
    self.quantity.toCheck = 0;
  }

  // если больше
  if (self._isMoreThenMax()) {
    if (method == 'changeQuantity') {
      Products.getInstance($product).then(function(product) {
        EventBus.publish('overload:quantity:insales:product', {
          action: {
            method: method,
            product: $product,
            productJson: product.product,
            button: config && config.button ? config.button : null
          },
          max: self.quantity.max,
          input: self.$input,
          title: product.product.title,
          product_id: product.product.id
        });
      });
    } else {
      if ($product.length == 0) {
        return;
      }
      Products.getInstance($product).then(function(product) {
        EventBus.publish('max:quantity:insales:product', {
          action: {
            method: method,
            product: $product,
            productJson: product.product,
            button: config && config.button ? config.button : null
          },
          max: self.quantity.max,
          input: self.$input,
          title: product.product.title,
          product_id: product.product.id
        });
      });
    }

    self.quantity.toCheck = self.quantity.max;
    self.status.more = true;
  }

  // ушли меньше возможного минимума
  if (self._isLessThenMin()) {
    self.quantity.toCheck = self.quantity.min;
    self.status.less = true;
  }

  // после всех этих хитрых манипуляций у нас что-то изменилось?
  if (self.quantity.current !== self.quantity.toCheck) {
    self.quantity.current = self._fixValue(self.quantity.toCheck);
    self.status.change = true;
  }

  // дергаем статусы
  self._update();
};

/**
 * @private
 */
InstanceQuantity.prototype._isMoreThenMax = function() {
  var self = this;
  var _withMax = !_isNull(self.quantity.max);
  var _isMore = self.quantity.toCheck > self.quantity.max;
  var _status;

  _status = _isMore && _withMax && self.settings.useMax;

  return _status;
};

/**
 * @private
 * проверяем, меньше ли текущее число допустимого минимума
 * и учитываем случай, что у нас данный вариант может кончиться
 */
InstanceQuantity.prototype._isLessThenMin = function() {
  var self = this;
  var _isLess = self.quantity.toCheck < self.quantity.min;
  var _status;

  _status = _isLess && !self.status.stockOut;

  return _status;
};

/**
 * Обновляем мир
 * @private
 */
InstanceQuantity.prototype._update = function() {
  var self = this;

  if (self.warehouse_id) {
    // При обновлении количества в мультикорзине нам не нужно, чтобы оно обновлялось в других корзинах
    // Если прилетел action_warehouse_id, то это другая корзина и мы её не трогаем
    if (!self.action_warehouse_id) {
      self.$input.val(self.quantity.current.toFixed(self.decimal));
    }

    self.action_warehouse_id = null;
  } else {
    self.$input.val(self.quantity.current.toFixed(self.decimal));
  }

  // TODO: необоходимо проверить выподнение с разными флагами
  if (self._isChanged()) {
    EventBus.publish('product_instance:insales:system', {
      instanceId: self.instanceId,
      from: 'quantity'
    });
  }
};

/**
 * Вытаскиваем эекземпляр класса
 * @private
 */
InstanceQuantity.prototype._getInstance = function($selector) {
  var self = this;
  var _instance = $selector.parents(self.selectors.container.css)[0];

  if (_instance !== undefined) {
    _instance = _instance.Quantity;
  } else {
    // если не нашли экземпляр - говорим, что продолбалось, отваливаемся
    console.warn('Product: Quantity', 'Не указан блок "Количество товаров" для', $selector);

    return false;
  }

  return _instance;
};

/**
 * Биндим события
 * Использует модульный флаг для предотвращения повторной инициализации
 * @private
 */
InstanceQuantity.prototype._bindEvents = function() {
  var self = this;

  if (_bindEventsInitialized) {
    return false;
  }

  self._bindQuantityButtons();
  self._bindQuantityInput();
  self._bindCart();

  _bindEventsInitialized = true;
};

/**
 * Слушаем нажатия на кнопки +-
 * @private
 */
InstanceQuantity.prototype._bindQuantityButtons = function() {
  var self = this;

  jquery(document).on('click', self.selectors.button.css, function(event) {
    event.preventDefault();

    var $quantityButton = jquery(this);
    var quantity = self._getInstance($quantityButton);

    if (typeof quantity == 'undefined') {
      console.warn('Счетчик не инициализирован');
      InSalesUI.bindUpdateCart();
      EventBus.subscribe('after:insales:initAjaxInstance', function(data) {
        if (typeof quantity == 'undefined') {
          return;
        }
        quantity._changeQuantity($quantityButton.data(self.selectors.button.data), {
          byButton: true,
          button: $quantityButton
        });
      });
    } else {
      quantity._changeQuantity($quantityButton.data(self.selectors.button.data), {
        byButton: true,
        button: $quantityButton
      });
    }
  });
};

/**
 * Слушаем поле quantity
 * @private
 */
InstanceQuantity.prototype._bindQuantityInput = function() {
  var self = this;
  var _input = self.selectors.container.css + ' ' + self.selectors.input.css;
  var _debounceShort;

  function _updateQuantity(event, $target) {
    event.preventDefault();

    var instance = self._getInstance($target || jquery(this));
    if (instance) {
      instance._setQuantity();
    }
  }

  _debounceShort = _debounce(_updateQuantity, 250);

  jquery(document).find(self.selectors.container.css).attr(self.selectors.container.attr_init, true);

  const dataQuantityInput = jquery(document).find('[data-quantity-input]');

  if (dataQuantityInput.length) {
    jquery(document).on('input', _input, _debounce(_updateQuantity, 500));
  }

  jquery(document)
    .on('blur', _input, _updateQuantity)
    .on('change', _input, _debounceShort)
    .on('keypress', _input, function(event) {
      event.stopPropagation();

      if (event.keyCode == 13) {
        _updateQuantity(event, jquery(this));
      }
    });
};
/**
 * Слушаем поле.
 * @private
 */
InstanceQuantity.prototype._bindCart = function() {
  var self = this;

  EventBus.subscribe('change_quantity:insales:item', function(variantData) {
    if (variantData.action && variantData.action.quantity.current && variantData.action.quantityInput) {
      const instanceTrigger = self._getInstance(jquery(variantData.action.quantityInput));
      const $items = jquery('[name="cart[quantity][' + variantData.id + ']"]');

      if ($items.length > 1) {
        $items.each(function(index, el) {
          // Если в action варианта содержится информация об опциях, то нужно найти вариант именно с этим набором опций, а потом выполнять необходимые действия
          if (variantData.action.accessory_value_ids) {
            const accessoriesData = getCartItemAccessoriesData(el.closest('[data-item-id]'));

            if (!haveSameKeys(variantData.action.accessory_value_ids, accessoriesData)) {
              return;
            }
          }

          const currentVal = _toNumber(jquery(el).val());
          const ajaxCart = variantData.action.quantityInput.parents('[data-ajax-cart]');

          if (currentVal != variantData.action.quantity.current
            && !jquery(el).is(variantData.action.quantityInput)
            && ajaxCart.length == 0) {
            const instance = self._getInstance(jquery(el));
            if (instance) {
              if (variantData.action.warehouse_id) {
                instance.action_warehouse_id = variantData.action.warehouse_id;
              }

              instance.quantity.toCheck = instanceTrigger.quantity.toCheck;
              instance.quantity.current = instanceTrigger.quantity.current;
              instance._check(null, 'setQuantity', true);
            }
          }
        });
      }
    }
  });
};

/**
 * Чиним значения
 * @private
 */
InstanceQuantity.prototype._fixValue = function(_value) {
  var self = this;

  return _round(_toFinite(_value), self.decimal);
};

/**
 *
 */
InstanceQuantity.prototype.getInput = function() {
  var self = this;
  var _input = self.$input;

  return _input;
};

/**
 *
 */
InstanceQuantity.prototype.getStatus = function() {
  var self = this;
  var _status;

  self.status.checked = true;
  _status = self.status;

  return _status;
};

/**
 * @private
 */
InstanceQuantity.prototype._isChanged = function() {
  var self = this;
  var _isChanged = false;

  _isChanged = (self.status.change || self.status.more || self.status.less) && !self.status.checked;

  return _isChanged;
};

/**
 *
 */
InstanceQuantity.prototype.getVariantFromNode = function() {
  var self = this;
  var _name = _words(self.$input.attr('name'));
  var _variant_id;

  if (_name[0] == 'variant' || _name[0] == 'cart') {
    _variant_id = _toInteger(_name[2]);
  }

  return _variant_id;
};

export default InstanceQuantity;
